import { GridSortableContext } from './GridSortableContext';
import { GridDraggableCardItem } from './GridDraggableCardItem';
import { DraggableCardOverlay } from './DraggableCardOverlay';

import { DragAndDrop } from '../DragAndDrop';

export const CardsGridDragAndDrop: DragAndDrop = {
  SortableContext: GridSortableContext,
  DraggableCard: GridDraggableCardItem,
  DraggableCardOverlay,
};
